import { createElement } from '../../../core/dom/helpers.js';

/** @type {import('../../../contracts/forms.js').FieldDriver} */
export const checkboxDriver = {
  type: 'checkbox',
  mount(container, ctx) {
    const { def, onChange } = ctx;

    const input = /** @type {HTMLInputElement} */ (createElement('input', {
      type: 'checkbox',
      id: `field-${def.key}`,
      name: def.key,
      class: 'form-field-checkbox',
    }));
    if (def.disabled) input.setAttribute('disabled', 'disabled');
    if (def.required) {
      input.required = true;
      input.setAttribute('aria-required', 'true');
    }
    input.addEventListener('change', () => onChange(input.checked));

    container.appendChild(input);

    if (ctx.value !== undefined) {
      input.checked = Boolean(ctx.value);
    }

    return {
      setValue(value) {
        input.checked = Boolean(value);
      },
      getValue() {
        return input.checked;
      },
      setErrors() {
        // errors rendered by host
      },
      destroy() {
        input.remove();
      },
      setDisabled(disabled) {
        input.disabled = disabled;
      },
      clearValue() {
        input.checked = false;
      },
      setAriaInvalid(invalid) {
        input.setAttribute('aria-invalid', invalid ? 'true' : 'false');
      },
    };
  },
};
